import { Box, useTheme } from "@mui/material";
import React, { ReactNode } from "react";

interface MessageBubbleProps {
  variant: "user" | "assistant";
  avatar?: ReactNode;
  minWidth?: string;
  children: ReactNode;
}

const MessageBubbleComponent: React.FC<MessageBubbleProps> = ({
  variant,

  children,
  minWidth,
}) => {
  const theme = useTheme();
  const { chatTheme } = theme;
  const isDarkMode = theme.palette.mode === "dark";

  // Get color set based on message variant
  const isUser = variant === "user";
  const colorSet = isDarkMode
    ? isUser
      ? chatTheme.colors.user.dark
      : chatTheme.colors.assistant.dark
    : isUser
      ? chatTheme.colors.user.light
      : chatTheme.colors.assistant.light;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: variant === "user" ? "flex-end" : "flex-start",
        alignItems: "flex-start",
        gap: chatTheme.spacing.avatarGap,
        mb: chatTheme.spacing.componentMargin,
      }}
    >
      <Box
        sx={{
          p: chatTheme.spacing.messageBubblePadding,
          borderRadius: chatTheme.borderRadius.messageBubble,
          width: variant === "user" ? "auto" : "100%",
          maxWidth: variant === "user" ? chatTheme.messageBubble.maxWidth : "100%",
          minWidth: minWidth || chatTheme.messageBubble.minWidth,
          wordBreak: "break-word",
          position: "relative",
          color: colorSet.text,
          backgroundColor: variant === "user" ? colorSet.background : "transparent",
          border: variant === "assistant" ? "1px solid #E7E7E7" : "none",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export const MessageBubble = React.memo(MessageBubbleComponent);
